import {useEffect} from "react";
import {useSelector} from "react-redux";

import {useUserDevice} from "@pg-mono/user-device";

import {IRPStore} from "../../../app/rp_reducer";
import {getRecommendationFromProperty} from "../../../recommendations/utils/get_recommendation_from_property";
import {RecommendedOfferApplicationsType} from "../../actions/multi_lead/track_recommended_offers_application";
import {useMultiLeadRecommendations} from "../../hooks/multi_lead/use_application_multi_lead_recommendations";
import {useTransformApplicationToMultiLead} from "../../hooks/multi_lead/use_application_multi_lead_transform";
import {IApplicationFormValues} from "../../types/form/IApplicationFormValues";
import {IApplicationData} from "../../types/IApplicationData";
import {ApplicationMultiLeadRecommendationType} from "../../types/multi_lead/ApplicationMultiLeadRecommendationType";
import {ApplicationMultiLeadRecommendedPropertyType} from "../../types/multi_lead/ApplicationMultiLeadRecommendedPropertyType";
import {IApplicationMultiLeadData} from "../../types/multi_lead/IApplicationMultiLeadData";
import {IApplicationMultiLeadSetSummaryStepPayload} from "../../types/multi_lead/IApplicationMultiLeadSetSummaryStepPayload";
import {IApplicationMultiLeadSummaryStepState} from "../../types/multi_lead/IApplicationMultiLeadSummaryStepState";
import {ApplicationSourceSection} from "../../utils/form/application_form_source";
import {
    transformRecommendedOfferIntoMultiLeadData,
    transformRecommendedPropertyIntoMultiLeadData
} from "../../utils/multi_lead/application_multi_lead_transform_to_data";
import {isRecommendationRecommendedProperty} from "../../utils/multi_lead/is_recommendation_recommended_property";
import {shouldApplicationPriceBeenShown} from "../../utils/should_application_price_been_shown";
import {ApplicationMultiLeadSimpleRecommendationsModal} from "./ApplicationMultiLeadSimpleRecommendationsModal";
import {ApplicationMultiLeadWrapper} from "./ApplicationMultiLeadWrapper";

interface IProps {
    originalApplicationResponse: IApplicationData | null;
    sourceSection: ApplicationSourceSection;
    storeHash: string;
    recommendationType: ApplicationMultiLeadRecommendationType;
    originalApplicationFormValues: IApplicationFormValues;
    recommendationsWithPriceFilter: boolean;
    offerId?: number;
    propertyId?: number;
    customSourceSection?: string;
    handleModalClose: (payload?: IApplicationMultiLeadSetSummaryStepPayload) => void;
    handleSetMultiLeadSummaryStep: (payload: IApplicationMultiLeadSummaryStepState) => void;
}

export const ApplicationMultiLead = (props: IProps) => {
    const {
        handleModalClose,
        handleSetMultiLeadSummaryStep,
        originalApplicationFormValues,
        originalApplicationResponse,
        recommendationType,
        recommendationsWithPriceFilter,
        sourceSection,
        storeHash,
        customSourceSection,
        offerId,
        propertyId
    } = props;

    const {isMobile} = useUserDevice();
    const originalApplication = useSelector((store: IRPStore) => store.application[storeHash]);
    const multiLeadProperty = originalApplication?.property?.detail;
    const {transformedApplications} = useTransformApplicationToMultiLead({
        storeHash,
        originalApplicationResponse,
        originalApplication,
        multiLeadProperty
    });

    const {areRecommendationsEmpty} = useMultiLeadRecommendations({
        propertyId,
        offerId
    });

    useEffect(() => {
        if (areRecommendationsEmpty) {
            handleSetMultiLeadSummaryStep({
                multiLeadSummaryItems: transformedApplications,
                multiLeadProperty
            });
        }
    }, [areRecommendationsEmpty]);

    const onSimpleVariantSuccessfulSubmit = (applications: ApplicationMultiLeadRecommendedPropertyType[] | RecommendedOfferApplicationsType[]) => {
        handleSetMultiLeadSummaryStep({
            multiLeadSummaryItems: applications
                .map(([application, appliedRecommendation]) => {
                    if (isRecommendationRecommendedProperty(appliedRecommendation)) {
                        const recommendedProperty =
                            isRecommendationRecommendedProperty(appliedRecommendation) && "additional_files" in appliedRecommendation
                                ? getRecommendationFromProperty(appliedRecommendation)
                                : appliedRecommendation;
                        return transformRecommendedPropertyIntoMultiLeadData(recommendedProperty, {
                            isPriceRevealed: shouldApplicationPriceBeenShown(application)
                        });
                    }
                    if (!isRecommendationRecommendedProperty(appliedRecommendation)) {
                        return transformRecommendedOfferIntoMultiLeadData(appliedRecommendation);
                    }
                    return undefined;
                })
                .filter((item): item is IApplicationMultiLeadData => item !== undefined),
            multiLeadProperty
        });
    };

    const onCloseClick = () => {
        handleModalClose();
    };

    return (
        <ApplicationMultiLeadWrapper isScrollable={Boolean(isMobile)}>
            <ApplicationMultiLeadSimpleRecommendationsModal
                originalApplicationFormValues={originalApplicationFormValues}
                recommendationsWithPriceFilter={recommendationsWithPriceFilter}
                storeHash={storeHash}
                sourceSection={sourceSection}
                onModalClose={onCloseClick}
                onSuccessfulSubmit={onSimpleVariantSuccessfulSubmit}
                recommendationType={recommendationType}
                customSourceSection={customSourceSection}
                originalApplicationResponse={originalApplicationResponse}
            />
        </ApplicationMultiLeadWrapper>
    );
};
import {useEffect} from "react";
import {useSelector} from "react-redux";

import {useUserDevice} from "@pg-mono/user-device";

import {IRPStore} from "../../../app/rp_reducer";
import {getRecommendationFromProperty} from "../../../recommendations/utils/get_recommendation_from_property";
import {RecommendedOfferApplicationsType} from "../../actions/multi_lead/track_recommended_offers_application";
import {useMultiLeadRecommendations} from "../../hooks/multi_lead/use_application_multi_lead_recommendations";
import {useTransformApplicationToMultiLead} from "../../hooks/multi_lead/use_application_multi_lead_transform";
import {IApplicationFormValues} from "../../types/form/IApplicationFormValues";
import {IApplicationData} from "../../types/IApplicationData";
import {ApplicationMultiLeadRecommendationType} from "../../types/multi_lead/ApplicationMultiLeadRecommendationType";
import {ApplicationMultiLeadRecommendedPropertyType} from "../../types/multi_lead/ApplicationMultiLeadRecommendedPropertyType";
import {IApplicationMultiLeadData} from "../../types/multi_lead/IApplicationMultiLeadData";
import {IApplicationMultiLeadSetSummaryStepPayload} from "../../types/multi_lead/IApplicationMultiLeadSetSummaryStepPayload";
import {IApplicationMultiLeadSummaryStepState} from "../../types/multi_lead/IApplicationMultiLeadSummaryStepState";
import {ApplicationSourceSection} from "../../utils/form/application_form_source";
import {
    transformRecommendedOfferIntoMultiLeadData,
    transformRecommendedPropertyIntoMultiLeadData
} from "../../utils/multi_lead/application_multi_lead_transform_to_data";
import {isRecommendationRecommendedProperty} from "../../utils/multi_lead/is_recommendation_recommended_property";
import {shouldApplicationPriceBeenShown} from "../../utils/should_application_price_been_shown";
import {ApplicationMultiLeadSimpleRecommendationsModal} from "./ApplicationMultiLeadSimpleRecommendationsModal";
import {ApplicationMultiLeadWrapper} from "./ApplicationMultiLeadWrapper";

interface IProps {
    originalApplicationResponse: IApplicationData | null;
    sourceSection: ApplicationSourceSection;
    storeHash: string;
    recommendationType: ApplicationMultiLeadRecommendationType;
    originalApplicationFormValues: IApplicationFormValues;
    recommendationsWithPriceFilter: boolean;
    offerId?: number;
    propertyId?: number;
    customSourceSection?: string;
    handleModalClose: (payload?: IApplicationMultiLeadSetSummaryStepPayload) => void;
    handleSetMultiLeadSummaryStep: (payload: IApplicationMultiLeadSummaryStepState) => void;
}

export const ApplicationMultiLead = (props: IProps) => {
    const {
        handleModalClose,
        handleSetMultiLeadSummaryStep,
        originalApplicationFormValues,
        originalApplicationResponse,
        recommendationType,
        recommendationsWithPriceFilter,
        sourceSection,
        storeHash,
        customSourceSection,
        offerId,
        propertyId
    } = props;

    const {isMobile} = useUserDevice();
    const originalApplication = useSelector((store: IRPStore) => store.application[storeHash]);
    const multiLeadProperty = originalApplication?.property?.detail;
    const {transformedApplications} = useTransformApplicationToMultiLead({
        storeHash,
        originalApplicationResponse,
        originalApplication,
        multiLeadProperty
    });

    const {areRecommendationsEmpty} = useMultiLeadRecommendations({
        propertyId,
        offerId
    });

    useEffect(() => {
        if (areRecommendationsEmpty) {
            handleSetMultiLeadSummaryStep({
                multiLeadSummaryItems: transformedApplications,
                multiLeadProperty
            });
        }
    }, [areRecommendationsEmpty]);

    const onSimpleVariantSuccessfulSubmit = (applications: ApplicationMultiLeadRecommendedPropertyType[] | RecommendedOfferApplicationsType[]) => {
        handleSetMultiLeadSummaryStep({
            multiLeadSummaryItems: applications
                .map(([application, appliedRecommendation]) => {
                    if (isRecommendationRecommendedProperty(appliedRecommendation)) {
                        const recommendedProperty =
                            isRecommendationRecommendedProperty(appliedRecommendation) && "additional_files" in appliedRecommendation
                                ? getRecommendationFromProperty(appliedRecommendation)
                                : appliedRecommendation;
                        return transformRecommendedPropertyIntoMultiLeadData(recommendedProperty, {
                            isPriceRevealed: shouldApplicationPriceBeenShown(application)
                        });
                    }
                    if (!isRecommendationRecommendedProperty(appliedRecommendation)) {
                        return transformRecommendedOfferIntoMultiLeadData(appliedRecommendation);
                    }
                    return undefined;
                })
                .filter((item): item is IApplicationMultiLeadData => item !== undefined),
            multiLeadProperty
        });
    };

    const onCloseClick = () => {
        handleModalClose();
    };

    return (
        <ApplicationMultiLeadWrapper isScrollable={Boolean(isMobile)}>
            <ApplicationMultiLeadSimpleRecommendationsModal
                originalApplicationFormValues={originalApplicationFormValues}
                recommendationsWithPriceFilter={recommendationsWithPriceFilter}
                storeHash={storeHash}
                sourceSection={sourceSection}
                onModalClose={onCloseClick}
                onSuccessfulSubmit={onSimpleVariantSuccessfulSubmit}
                recommendationType={recommendationType}
                customSourceSection={customSourceSection}
                originalApplicationResponse={originalApplicationResponse}
            />
        </ApplicationMultiLeadWrapper>
    );
};
